import { render, staticRenderFns } from "./VueConfirmDialog.vue?vue&type=template&id=8297cf6c&scoped=true&"
import script from "./VueConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./VueConfirmDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8297cf6c",
  null
  
)

export default component.exports